import apiClient from 'api/apiClient';
import API_END_POINT from 'constants/apiEndPoints';
import { ApiResponse, ProjectSummary } from 'types';

interface FetchProjectsParams {
  userEmail: string;
}

interface FetchProjectsResponse extends ApiResponse {
  projectList: ProjectSummary[];
}

type FetchProjects = (params: FetchProjectsParams) => Promise<FetchProjectsResponse>;

const fetchProjects: FetchProjects = async ({ userEmail }) => {
  const { data } = await apiClient.get(API_END_POINT.PROJECT.FETCH_PROJECTS, {
    params: {
      userEmail,
    },
  });

  return data;
};

export default fetchProjects;
